<template>
    <div>
        <div class="mainTitle text-center my-3">
            <h3>{{$t('AutochartistScanner')}}</h3>
        </div>
        <div class="maxContainer traderBox whiteBG radius mb-3 px-md-4 py-md-4 py-xs-3 border">
        	<div class="row justify-content-center">
        	 <div class="col-12 col-md-10 midMob">	
	        	<div class="row align-items-center">
					<div class="col-12 col-md-6 text-center">
						<div class="mb-2">
							<img src="../../../../static/fxView/images/auto-chartist-page.svg" alt="Email Support" class="mtImg-svg">
						</div>
						<!-- <div class="downloadBox-tool mb-0">
						 	<h5 class="m-0">
						 		
						 	</h5>
						</div> -->
					</div>
				    <div class="col-12 col-md-6">
					 <!-- <p>{{$t('AutochartistfinestSupplement')}}</p> -->
           			 <p>{{$t('IBintegrateAdvancedTool')}}</p>
           			 <a href="https://fxview.com/autochartist" class="btn_xs grd_btn clk" target="_blank">{{$t('moreaboutautochartist')}}  </a>
           			 <!-- <div class="mb-3 d-flex flex-wrap align-item-center justify-content-start" > 
						<a href="#" class="prism_btn darkBG btn_sm mr-md-3">Download AutoChartist Scanner</a>
						<a href="#" class="prism_btn btn_sm mr-md-3">User Guide</a> 
					</div> --> 
				  </div>
			     </div>
			  </div>
	  	    </div>
        </div>
         <div class="maxContainer traderBox mb-3">
        <div class="row">
            <div class="col-12 col-md-4">
            	<div class="subscribeReport border p-4 whiteBG">
            		<img src="../../../../static/fxView/images/sr_tradingaccount.png" alt="Email Support" class="mtImg">
                	<h5>{{$t('SubsMarketReports')}}</h5>
                	<a href="#" class="prism_btn btn_sm">{{$t('clickHere')}}</a>
            	</div>
            </div>
            <div class="col-12 col-md-4">
            	<div class="subscribeReport border p-4 whiteBG">
            		<img src="../../../../static/fxView/images/rocket_block.png" alt="Email Support" class="mtImg">
                    <h5>{{$t('userguide')}}</h5>
                    <a href="https://www.autochartist.com/metatrader-plugin/index-metatrader.html" target="_blank" class="prism_btn btn_sm">{{$t('clickHere')}} </a>
                </div>
            </div>
            <div class="col-12 col-md-4">
            	<div class="subscribeReport border p-4 whiteBG">
            		<img src="../../../../static/fxView/images/sr_chart.png" alt="Email Support" class="mtImg">
                    <h5>{{$t('TradOppCharts')}}</h5>
                    <a href="/auto-chartist" class="prism_btn btn_sm">{{$t('clickHere')}} </a> 
                </div>
            </div>
         </div>
        </div>
        <div class="maxContainer border traderBox mb-3 whiteBG px-md-4 py-md-4 py-xs-3">
	        <div class="row downloadT">
	        	<div class="col-12 mb-1">
	        	<h5 class="mb-1">{{$t('howToUse')}}</h5>
	                <!-- <p class="m-0">{{$t('usingTraderToolbox')}}</p>	 -->
	        	</div>
	        	<div class="col-12 col-md-6">
	                <ul class="listing p-3">
	                    <li>{{$t('closeMt4')}}</li>
	                    <li>{{$t('DownloadRunAuto')}}</li>
	                    <li>{{$t('SelectPortfoliosTrading')}}</li>
	                    <li>{{$t('completeInstallationProcess')}}</li>
	                    <li>{{$t('RestartMt4Platform')}}</li>
	                </ul>
	         </div> 
	        </div>
        </div>
        <div class="maxContainer border step-bottom-alert mb-5 whiteBG text-center justify-content-center">
			<span class="position-relative l-0"><feather type="alert-circle"></feather></span> 
			<p class="ml-2">{{$t('autochartistdesc')}} </p>
		</div>
        <div class="mb-2 text-center disclaimer darkBG p-3 row d-flex justify-content-center align-items-center">
			<div class="col-12 col-md-10">
				<small>{{$t('DisclaimerAutoChartist')}}</small>
			</div>
		</div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Signal-Centre',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				load_more_msz : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1
			}
		},
		methods:{
			loadList(){
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			listing(){
				let inputJson = {
					'globalParams' : {
						filter: {},
						sort: [],
						search: this.search,
						page: this.page,
						perPage: parseInt(this.pageLimit),
					} ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetSignalCentreData(inputJson)
			}
		},
		created(){
			if(this.$store.getters[Const.GET_SIGNAL_CENTRE] != ''){
				this.loaderFuncRun = '0'
			}
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/autochartist_scanner.vue